export default __webpack_public_path__ + "static/media/mua-sam.8bee6b19.jpg";